import { combineReducers } from '@reduxjs/toolkit';
import approvals from './Approvals/reducers';
import autofill from './Autofill/reducers';
import clients from './Clients/reducers';
import clusterAssignModal from './ClusterAssignModal/reducers';
import clusters from './Clusters/reducers';
import { reducer as development } from './Development/slice';
import items from './Items/reducers';
import modalReducer from './Modals/modal-slice';
import projects from './Projects/reducers';
import tasks from './Tasks/reducers';
import timesheet from './Timesheet/reducers';
import timesheetEntries from './TimesheetEntries/reducers';
import timesheetRows from './TimesheetRows/reducers';
import { reducer as timesheetStatus } from './TimesheetStatus/slice';
import user from './User/reducers';
import generalReducer from './general-slice';
import localReducer from './local-slice';

const rootReducer = combineReducers({
  approvals,
  autofill,
  clients,
  clusterAssignModal,
  clusters,
  development,
  general: generalReducer,
  items,
  local: localReducer,
  modal: modalReducer,
  projects,
  tasks,
  timesheet,
  timesheetEntries,
  timesheetRows,
  timesheetStatus,
  user,
});

export default rootReducer;
